import { useEffect, useState } from "react";
import { Server, CheckCircle2, AlertCircle, Loader2 } from "lucide-react";
import { aiApi } from "./aiApi";
import WaDiagnostics from "../superadmin/waai/WaDiagnostics";

/** Ringkasan sambungan bila pembekal aktif = API WhatsApp sendiri (paparan dalam panel AI Assistant). */
export default function AICustomWaSummary({ cfg }) {
  const [status, setStatus] = useState(null);
  useEffect(() => { aiApi.waStatus().then(setStatus).catch(() => setStatus({})); }, []);
  const ok = status?.connection?.connected;
  return (
    <div className="rounded-xl border border-slate-200 bg-slate-50/60 p-2 mb-2 space-y-2" data-testid="ai-custom-wa-summary">
      <div className="flex items-center gap-2">
        <Server className="h-4 w-4 text-emerald-600" />
        <div className="flex-1 text-[12px] font-bold text-slate-700">Sambungan WhatsApp — API Sendiri {cfg.sender_phone ? `(${cfg.sender_phone})` : ""}</div>
        {!status ? <Loader2 className="h-3.5 w-3.5 animate-spin text-slate-400" /> : ok
          ? <span className="flex items-center gap-1 text-[10px] font-bold text-emerald-700" data-testid="ai-custom-wa-status"><CheckCircle2 className="h-3.5 w-3.5" />Disambung</span>
          : <span className="flex items-center gap-1 text-[10px] font-bold text-rose-600" data-testid="ai-custom-wa-status"><AlertCircle className="h-3.5 w-3.5" />{status.connection?.state || "Belum disambung"}</span>}
      </div>
      <WaDiagnostics status={status} />
      <div className="text-[11px] text-slate-500">Mimi Junior guna nombor ini untuk laporan, amaran & balas mesej. Urus sambungan, peranan & perbualan di <b>Superadmin → WhatsApp AI</b>.</div>
    </div>
  );
}
